import { TransferScopeEnum } from '@tassat/fred-definitions';

// Core sends TransferScope over the wire as the ASCII code of the digit character
// (e.g. 49 => '1'), the same convention handled elsewhere for single-char fields
// (see WithdrawalType/WithdrawalTypeEnum in withdrawalInstructionDetails.tsx).
export const transferScopeCodeToEnum = (value: TransferScopeEnum | number | undefined): TransferScopeEnum | null => {
    if (value === undefined) {
        return null;
    }

    const scope = typeof value === 'number' ? String.fromCharCode(value) as TransferScopeEnum : value;

    return Object.values(TransferScopeEnum).includes(scope) ? scope : null;
};
